import { Div } from "../../base/components/native/div"

export const DeleteButton = (title: string = 'به روز رسانی موارد انتخاب شده') => {
    const base = Div(title)

    base.cssClass({
        margin: '20px 0',
        minWidth: '200px',
        textAlign: 'center',
        border: '1px solid crimson',
        position: 'absolute',
        borderRadius: '10px',
        height: '47px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        userSelect: 'none',
        cursor: 'pointer',
        boxShadow: 'rgba(0, 0, 0, 0.17) 0px 2px 5px',
        '&:hover': {
            borderColor: '#d32f2f',
        },
        '&:active': {
            transform: 'translateY(1px)',
            boxShadow: 'none',
        }
    })

    base.el.addEventListener('click', () => {
        base.emit('click')
    })

    return Object.assign(base, {
        enable: () => {
            base.style({
                cursor: 'pointer', pointerEvents: 'auto',
                opacity: '1',
                filter: 'saturate(1)',

            })
        },
        disable: () => {
            base.style({
                cursor: '', pointerEvents: 'none',

                opacity: '.5',
                filter: 'saturate(.2)',
            })
        }
    })
}